import clg from "functions/log";
import React from "react";

const SectionTitle = ( props ) => {

    const title = ( props.title ? props.title : "" );
    const description = ( props.description ? props.description : null );
    const hTagType = ( props.hTagType ? props.hTagType : "h2" );

    return (
        <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-6">

                {React.createElement(
                    `${hTagType}`,
                     {className: "font-weight-bold heading text-primary mb-4"},
                     title
                )}

                {
                    description && (
                        <p>{ description }</p>
                    )
                }
            </div>
        </div>
    )
}

const Section = ( props ) => {

    const title = ( props.title ? props.title : "" );
    const description = ( props.description ? props.description : "" );
    const additionalClasses = ( props.additionalClasses ? props.additionalClasses : null );
    const hTagType = ( props.hTagType ? props.hTagType : "h2" );

    return (
        <div className={"section" + ( additionalClasses ? " " + additionalClasses : "" )} id={props.id && props.id} ref={props.forwardRef && props.forwardRef}>
            <div className="container">
                {
                    ( title || description ) && (
                        <SectionTitle title={ title ? title : null } description={ description ? description : null } hTagType={ hTagType } />
                    )
                }
                {props.children}
            </div>
        </div>
    )
}

export default Section;